
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_144_161674)"}},[_c('path',{attrs:{"d":"M4 6h.005M6 6h.005M8 6h.005M3.95 10A4.5 4.5 0 102 8.05L1 11l2.95-1z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_144_161674"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    